// extracted by mini-css-extract-plugin
export var standaloneTable = "_hw-0";
export var standaloneTableWithBodyFill = "_hw-1";
export var withExtraHeader = "_hw-2";